<template>
  <div class="w-full">
    <div class="flex px-10 pt-6">
      <div class="pr-4">
        <CompressIcon />
      </div>
      <div v-if="!completeDownload">
        <p class="text-zt-xl text-zt-dark-500">
          {{ $t('message.DownloadAllDocuments.youWantDownloadAllDocs') }}
          <span class="font-semibold"
            >{{ totalDocuments }}
            {{ $t('message.DownloadAllDocuments.selectedDocuments') }}</span
          >
        </p>
        <p class="pt-6 text-zt-dark-500">
          {{ $t('message.DownloadAllDocuments.sendToLinkMail') }}
        </p>
        <div class="pt-6">
          <div
            class="w-full px-4 py-2 h-12 rounded download--email flex justify-between items-baseline"
          >
            <p class="font-bold text-zt-dark-500">{{ userEmail }}</p>
          </div>
          <p v-if="!userEmail" class="text-zt-danger text-zt-sm flex">
            <zt-icon name="exclamation-circle-outline mr-2 text-zt-lg" />
            <span>{{
              $t('message.DownloadAllDocuments.messageWarningNoEmail')
            }}</span>
          </p>
        </div>
        <div class="py-10 download--message text-zt-dark-300 leading-6">
          <p>
            {{ $t('message.DownloadAllDocuments.messageWarning') }}
          </p>
        </div>
      </div>
      <div v-else>
        <p class="font-bold pb-4 text-zt-xl">
          {{ $t('message.DownloadAllDocuments.preparingDocuments') }}
        </p>
        <p class="download--complete pb-4 text-zt-dark-400">
          {{ $t('message.DownloadAllDocuments.sendToLinkMailInMinutes') }}
        </p>
        <div class="pb-10">
          <div
            class="w-full px-4 py-2 rounded download--email flex justify-between items-baseline"
          >
            <p class="font-bold">{{ userEmail }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full bg-zt-dark-200 py-2 flex pr-6 rounded-b">
      <div class="ml-auto">
        <template v-if="!completeDownload">
          <button
            data-vs-button="close-cancel-modal"
            class="focus:outline-none mr-3 text-zt-dark-400 font-medium"
            @click="closeModal"
          >
            {{ $t('message.DownloadAllDocuments.cancel') }}
          </button>
          <zt-button
            data-vs-button="register-download"
            class="bg-zt-primary-200 text-white font-medium px-2"
            @click="registerDownload"
            :disabled="buttonDisable"
          >
            {{ $t('message.DownloadAllDocuments.yesDownload') }}
          </zt-button>
        </template>
        <template v-else>
          <button
            data-vs-button="close-success-modal"
            @click="closeModal"
            class="focus:outline-none bg-zt-primary-200 text-white font-medium download--success px-2"
          >
            {{ $t('message.DownloadAllDocuments.understood') }}
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import CompressIcon from '../SVG/CompressIcon'
export default {
  name: 'DownloadAll',
  inject: ['closeModal', 'editUserEmail', 'setUserEmail', 'registerDownload'],
  components: {
    CompressIcon
  },
  props: {
    completeDownload: {
      type: Boolean,
      default: false
    },
    totalDocuments: {
      type: Number,
      default: 0
    },
    userEmail: {
      type: String,
      default: ''
    },
    editEmail: {
      type: Boolean,
      default: false
    },
    buttonDisable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.download--link {
  color: #2743b3;
}

.download--success {
  height: 34px;
  border-radius: 4px;
  background-color: var(--branding-primary, --v-primary-base);
  border: 1px solid var(--branding-primary, --v-primary-base);
}

.download--message {
  font-size: 12px;
}

.download--email {
  border: 1px solid rgba(0, 0, 0, 0.36);
  background-color: #c4c4c4;
}

.download--complete {
  font-size: 16px;
}
</style>
